import { startCase, toLower } from 'lodash'
import React, { FC } from 'react'
import { AbstractEmail } from '../AbstractEmail'
import { VideoSubmissionType } from '../VideoPresentationContainer/VideoPresentationContainer'
import { OralPresentionStyle } from './styled'

interface VideoPresentationProps {
  video: VideoSubmissionType
}
const vimeoCodes = [
  {id: 92, h: 'fd38c7ec5f'},
  {id: 91, h: '9eb482d392'},
  {id: 90, h: '419d1347ea'},
  {id: 79, h: 'b21ad5581a'},
  {id: 45, h: 'f4d27fff30'},
  {id: 44, h: '8d182663d3'},
  {id: 41, h: '43adb1eb41'},
  {id: 21, h: '845e0ff6a6'},
  {id: 85, h: '0873fbad85'},
  {id: 33, h: '9ecc73339b'},
  {id: 31, h: '9536edc064'},
  {id: 30, h: '20d07fed1e'},
  {id: 29, h: '1d93fa8853'},
  {id: 28, h: '3e32768e07'},
  {id: 27, h: 'b754497dca'},
  {id: 17, h: 'ca186e43cd'},
  {id: 37, h: '01795d8fcc'},
  {id: 84, h: 'a8ef8a2ae8'},
  {id: 81, h: '5f1d929e43'},
  {id: 80, h: 'c5cbb08149'},
  {id: 43, h: '93bf293e4f'},
  {id: 34, h: '364c03cf87'},
  {id: 11, h: '29aad2e949'},
]

export const VideoPresentation: FC<VideoPresentationProps> = ({ video }) => {
  const getVimeoUrl = () => {
    const VIMEO_PARAMS = {
      title: '0',
      autoplay: '1',
      h: vimeoCodes.find(code => code.id == video?.id)?.h,
    }
    const params = new URLSearchParams(VIMEO_PARAMS).toString()
    const videoId = video?.submission_video ? video.submission_video.vimeo_id : ''

    return `https://player.vimeo.com/video/${videoId}?${params}`
  }

  return (
    <OralPresentionStyle>
      <div id="vimeoContainer">
        <iframe
          src={getVimeoUrl()}
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
          title={video.title}
        ></iframe>
        <script src="https://player.vimeo.com/api/player.js"></script>
      </div>
      <section id="bottomSection">
        <div>
          <p className="text-muted mb-2">{video.area_of_interest}</p>
          <h4 className="abstractTitle">{video.title}</h4>
          <p className="authorName">{startCase(toLower(video.presenting_submitter_name))}</p>
        </div>
        <div className="interactionSection">
          <AbstractEmail email={video.presenter_email} />
        </div>
      </section>
    </OralPresentionStyle>
  )
}
